module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "support",
    attrs: {
      "name": "support",
      "height": "auto"
    }
  }, [_c('form', {
    attrs: {
      "method": "post",
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_c('h4', [_vm._v(_vm._s(_vm.t('Report a note') + '/' + _vm.t('Ask a question')))])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.change(_vm.type)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": ""
    }
  }, [_vm._v("-" + _vm._s(_vm.t('Select')) + "-")]), _vm._v(" "), _vm._l((_vm.options), function(option, key) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(_vm.t(option.name)))])
  })], 2), _vm._v(" "), (_vm.type) ? _c('blockquote', [_vm._v("\n                    " + _vm._s(_vm.type.description) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.type) ? _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    staticStyle: {
      "min-height": "150px"
    },
    attrs: {
      "maxlength": "2500",
      "placeholder": _vm.t('Describe your application')
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "checked"
    }
  }), _vm._v(" " + _vm._s(_vm.t('Attach the browser information')) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "alert-dismissable alert-danger text-center"
  }, [_vm._v("\n                    " + _vm._s(_vm.error) + "\n                ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sent),
      expression: "sent"
    }],
    staticClass: "alert-dismissable alert-success text-center"
  }, [_vm._v("\n                    " + _vm._s(_vm.t('The application has been sent')) + "\n                ")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "pull-left btn btn-cancel btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.t('Cancel')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sending && !_vm.sent),
      expression: "!sending && !sent"
    }],
    staticClass: "btn btn-confirm btn-sm",
    attrs: {
      "type": "submit",
      "disabled": !_vm.type || !_vm.description
    },
    domProps: {
      "value": _vm.t('Send')
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sending),
      expression: "sending"
    }]
  }, [_vm._v(_vm._s(_vm.t('Sending')) + "...")])])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bd99ae80!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Support/index.vue
// module id = 1348
// module chunks = 2